"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANALYTICS_UNKNOWN = void 0;
exports.ANALYTICS_UNKNOWN = 'n/a';
